import { useEffect, useState } from "react";
import { TonConnectButton, useTonAddress } from "@tonconnect/ui-react";
import type { WallRef } from "./api";
import { fetchDirectory, fetchHot } from "./api";

interface Props {
  ownSlug: string;
  onPick: (slug: string) => void;
  onClose: () => void;
}

export function Discover({ ownSlug, onPick, onClose }: Props) {
  const [directory, setDirectory] = useState<WallRef[]>([]);
  const [hot, setHot] = useState<WallRef[]>([]);
  const [tag, setTag] = useState("");
  const tonAddress = useTonAddress();

  useEffect(() => {
    void fetchDirectory().then(setDirectory);
    void fetchHot().then(setHot);
  }, []);

  const interests = directory.filter((w) => w.type === "interest");

  function openTag() {
    const clean = tag.trim().replace(/^#/, "").toLowerCase();
    if (clean) onPick(`tag:${clean}`);
  }

  return (
    <div className="discover">
      <div className="discover-head">
        <button className="ghost" onClick={onClose}>
          ← Назад
        </button>
        <span className="discover-title">Куда заглянем?</span>
      </div>

      <div className="quick">
        <button className="quick-btn" onClick={() => onPick(ownSlug)}>
          ✍️ Моя стена
        </button>
        <button className="quick-btn" onClick={() => onPick("global")}>
          🌍 Общая стена
        </button>
      </div>

      <form
        className="tag-search"
        onSubmit={(e) => {
          e.preventDefault();
          openTag();
        }}
      >
        <span className="hash">#</span>
        <input
          className="composer-input"
          placeholder="хэштег: music, memes…"
          value={tag}
          onChange={(e) => setTag(e.target.value)}
        />
        <button className="send-btn" type="submit" aria-label="Открыть хэштег">
          →
        </button>
      </form>

      {hot.length > 0 && (
        <section className="disco-section">
          <h3 className="section-title">🔥 Горячее</h3>
          <div className="chips">
            {hot.map((w) => (
              <button key={w.slug} className="chip" onClick={() => onPick(w.slug)}>
                {w.title ?? w.slug}
                {w.count ? <span className="chip-count">{w.count}</span> : null}
              </button>
            ))}
          </div>
        </section>
      )}

      <section className="disco-section">
        <h3 className="section-title">🎯 Интересы</h3>
        <div className="chips">
          {interests.map((w) => (
            <button key={w.slug} className="chip" onClick={() => onPick(w.slug)}>
              {w.title ?? w.slug}
            </button>
          ))}
          {interests.length === 0 && <span className="hint-text">скоро…</span>}
        </div>
      </section>

      <section className="disco-section">
        <h3 className="section-title">🪙 TON-кошелёк</h3>
        <TonConnectButton />
        {tonAddress && (
          <div className="hint-text" style={{ marginTop: 8 }}>
            Подключён: {tonAddress.slice(0, 6)}…{tonAddress.slice(-4)}
          </div>
        )}
      </section>
    </div>
  );
}
